import React, { useContext } from 'react';
// eslint-disable-next-line import/no-cycle
import { TableContext } from '../../CustomTable';
import classes from './Row.module.scss';

export default function Row({ withLines = false, children }) {
  const ctx = useContext(TableContext);

  return (
    <div className={`${classes.row} ${withLines ? classes.withBorder : ''}`} style={{ ...ctx.gridStyles }}>
      {children}
    </div>
  );
}
